module.exports = __webpack_public_path__ + "static/model-g-qr.4f0ff050efb34aac70666989da8ac78a.svg";